/** @format */

import * as React from 'react';

export const IconSmoking = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6855 9.78954L19.7494 4.81582L22.0001 7.0262L16.9362 11.9999M14.6855 9.78954L3.99527 20.2895L6.24586 22.5L16.9362 11.9999M14.6855 9.78954L16.9362 11.9999M3.43211 18.0791C0.0414624 14.5272 0.553891 11.9999 3.99527 11.9999C10.1402 11.9999 10.004 5.71711 3.99527 4.29395"
        stroke="#313140"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  );
};
